var app = angular.module("leonardo");

var CategoryFormController = function($scope, $state, formObj, CategoryRestService, SubCategoryRestService,
                                      FormErrorsService, SectorRestService) {

  $scope.data = formObj;

  $scope.sectorRestService = SectorRestService;

  $scope.service = $state.current.subcategory ? SubCategoryRestService : CategoryRestService;

  $scope.back = $state.current.subcategory ? 'categories.subcategories' : 'categories.list';

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = angular.copy($scope.data);
    if ($scope.data.sector) {
      data['sector'] = angular.isArray($scope.data.sector) ? $scope.data.sector : $scope.data.sector.split(',');
    }
    else {
      data['sector'] = [];
    }
    if ($state.current.action === 'edit'){
      $scope.data.patch(data).then(function(){
        if ($state.current.subcategory) {
          $state.go('categories.subcategories');
        }
        else {
          $state.go('categories.list');
        }
      });
    }
    else {
      $scope.service.post(data).then(function(result) {
        $scope.service.updateCollection(result);
        if ($state.current.subcategory) {
          $state.go('categories.subcategories');
        }
        else {
          $state.go('categories.list');
        }
      });
    }
  };
};

app.controller('CategoryFormController', ['$scope', '$state', 'formObj', 'CategoryRestService',
  'SubCategoryRestService', 'FormErrorsService', 'SectorRestService', CategoryFormController]);
